/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadDynamicImagesDetails() {
  return await api
    .get(`/dynamic-images/get-all-data`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDestinationDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/destination/get-all-data${destinations ? destinations : ""}`)
    .then((response) => response.data);
}
export async function loadPackageCategoryDetails(destinations) {
  // const params = { destinations };
  // console.log(params, "params");
  return await api
    .get(`/packageCategory/get-all-data${destinations ? destinations : ""}`)
    .then((response) => response.data);
}

export async function createPaymentInDetails(paymentDetails) {
  return await api
    .post(`/org/addpaymentin`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadBestSellingDetailsImagesList(imageList) {
  return await api
    .get(`/dynamic-images/best-selling-info`, imageList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadDealsDetails(dealsList) {
  return await api
    .get(`/dynamic-images/deals-you-cant-miss-info`, dealsList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadHolidaysDetails(holidayList) {
  const params = { holidayList };
  console.log(params, "params");
  return await api
    .get(`/dynamic-images/handpicked-holiday-info/${holidayList}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadTestimonialDetails(testimonialList) {
  return await api
    .get(`/testimonial/get-all-data`, testimonialList)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function updatePaymentInDetails(paymentDetails) {
  return await api
    .put(`/org/editpaymentin`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePaymentInDetails(paymentDetails) {
  return await api
    .post(`/org/deletePaymentIn`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadDynamicImagesDetails,
  loadDestinationDetails,
  loadPackageCategoryDetails,
  createPaymentInDetails,
  loadRecordsMetaData,
  updatePaymentInDetails,
  deletePaymentInDetails,
  loadBestSellingDetailsImagesList,
  loadDealsDetails,
  loadHolidaysDetails,
  loadTestimonialDetails,
};

export default remotes;
